const APP_DEVELOPER = false;

const BASE_URL_PRODUCTION = "https://api.mariomendez.uy/";
const BASE_URL_LOCAL = "http://localhost:8888/mario_mendez_api/";

export const Constants = {
  BASE_URL: APP_DEVELOPER ? BASE_URL_LOCAL : BASE_URL_PRODUCTION,
};
